import React from 'react';
import styled from 'styled-components';

export const FormGroup = ({ id, label, inline, children, ...restProps }) => (
  <Container inline={inline} {...restProps}>
    {label && <Label htmlFor={id}>{label}</Label>}
    {children}
  </Container>
);

const Container = styled.div`
  display: flex;
  flex-direction: ${(p) => (p.inline ? 'row' : 'column')};
  align-items: ${(p) => p.inline && 'center'};
  margin-bottom: 24px;
`;
const Label = styled.label`
  margin-bottom: 4px;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
`;
